export enum ERROR_TYPE {
  ERROR = 'error',
  DUPLICATED = 'duplicated',
  WRONGPW = 'wrongpw',
  IS_INIT_MIG = 'isinitmig',
  FAILED = 'failed'
}